import { FC, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

type Props = {
  imgSrc: string;
  delay?: number;
};

const CardItem: FC<Props> = ({ imgSrc, delay = 0 }): JSX.Element => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      opacity: 1,
      translateY: 0,
      transition: { duration: 0.5, delay, ease: "easeOut" },
    });
  }, [controls, delay]);

  return (
    <motion.div
      initial={{
        opacity: 0,
        translateY: 30,
      }}
      animate={controls}
      className="rounded-md bg-yellow-500 bg-cover bg-no-repeat"
      style={{
        backgroundImage: `url(${imgSrc})`,
      }}
    />
  );
};
export default CardItem;
